export const styles = {
  container: {
    position: 'relative',
    minHeight: 40,
    '& .SearchAndFilters-filterGroup': {
      display: 'inline-block',
      marginRight: 35,
      marginBottom: 20,
      textAlign: 'left',
    },
  },
  searchContainer: {
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  searchBox: {
    backgroundColor: 'white',
    borderRadius: 4,
  },
  presets: {
    marginLeft: '10px',
  },
}
